import * as THREE from 'three'
import 'imports-loader?THREE=three!three/examples/js/controls/OrbitControls.js'

export default class Controller {
  private controls: THREE.OrbitControls
  public constructor(camera: THREE.Camera, canvas: HTMLCanvasElement) {
    this.controls = new THREE.OrbitControls(camera, canvas)
    this.controls.enablePan = false
    this.controls.enableZoom = true
    this.controls.enableKeys = false // NOTE これ重要。バグかわからないが、他の無関係のテキストボックス上のキー操作で再描画不能になる。
    this.controls.update()
  }

  public update(): void {
    this.controls.update()
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Controller.ts